module.exports = __webpack_public_path__ + "img/empty.686a537d.png";